<template>
  <div class="w-full">
    <div class="flex w-full items-center justify-between px-spacing_2">
      <Button
        class="truncate"
        :c_style="{ type: 'tertiary', style: 'B' }"
        :label="title"
        :prefix_icon="titleIcon"
        :class="{ '!font-semibold': isSelected }"
        @click.prevent="$emit('select', { title, id })"
      />

      <CommonUIcons
        v-if="options"
        class="cursor-pointer transition-transform duration-500"
        size="24px"
        :name="iconName"
        :class="{
          'rotate-180': isOpen && ($device.isDesktop || !$device.isDesktop),
        }"
        :test-id="TEST_IDS.ACCORDION_BUTTON"
        @click.prevent="toggleDropdown"
      />
    </div>

    <Transition name="accordion">
      <div
        v-if="isOpen"
        class="w-full overflow-auto px-spacing_11 py-spacing_2"
      >
        <Button
          v-for="option in options"
          class="flex cursor-pointer items-center gap-1 px-spacing_7 py-spacing_6 hover:font-semibold"
          :c_style="{ type: 'tertiary', style: 'B' }"
          :key="option.title"
          :label="option.title"
          :class="{ '!font-semibold': option.isSelected }"
          @click.prevent="$emit('select', option)"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import type {
  AccordionButtonOption,
  AccordionButtonProps,
} from "~/types/schemas/common/Molecule/Accordion";
import TEST_IDS from "~~/tests/constants/ids";

defineEmits<{
  select: [item: AccordionButtonOption];
}>();

const props = defineProps<AccordionButtonProps>();

const isOpen = defineModel("is-open", {
  default: false,
});

const iconName = computed(() => {
  if (props.iconType === "arrow") {
    return "ic-arrow-right";
  }
  return isOpen.value ? "ic-minus" : "ic-plus";
});

const toggleDropdown = () => {
  if (props.options) {
    isOpen.value = !isOpen.value;
  }
};
</script>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  opacity: 1;
  transition:
    padding 100ms ease-in-out,
    opacity 100ms ease-in-out;
}

.accordion-enter-from,
.accordion-leave-to {
  padding: 0 var(--spacing_11);
  opacity: 0;
  background-color: transparent;
}

.accordion-enter-to,
.accordion-leave-from {
  padding: var(--spacing_2) var(--spacing_11);
  opacity: 1;
  background-color: transparent;
}
</style>
